exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separator[data-v-52b3a57e]{border:none;opacity:1;height:2px;background:var(--color-second-radial-gradient-1)}aside[data-v-52b3a57e]{text-align:right}aside>.current-menu-button[data-v-52b3a57e]{background:var(--color-third-0-8);color:var(--color-first);text-transform:uppercase;border-radius:0}aside>.current-menu-button>span.span-1[data-v-52b3a57e]{display:inline;font-size:larger;font-weight:400}aside>.current-menu-button>span.span-2[data-v-52b3a57e]{background:var(--color-first);color:var(--color-second);border-radius:50%;padding:.2rem}aside>hr[data-v-52b3a57e]{background:var(--color-second);margin:0 auto 2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52b3a57e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Banner.vue
// module id = 439
// module chunks = 10